import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Usuario, Usuario2 } from 'src/app/models/usuario.model';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportesService {

  token: string;
  idUsuario: string;
  path: string =  environment.URL_SERVICIOS.replace('/api/v1','');

  constructor(
    public http: HttpClient
  ) {
    this.cargarStorage();
  }

  cargarStorage() {

    if ( localStorage.getItem('tkn')) {
      this.token = localStorage.getItem('tkn');
      this.idUsuario = localStorage.getItem('uid');
    } else {
      this.token = '';
      this.idUsuario = '';
    }

  }

  getBase( date, currency ) {

    const url = `${environment.URL_SERVICIOS}/reports/start_date/${date}/currency/${currency}/layout_base?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );

  }

  getBanorte( date, currency ) {

    const url = `${environment.URL_SERVICIOS}/reports/start_date/${date}/layout_banorte?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );

  }

  getLySimBanorte(finicio, ffin) {
    const url = ` ${environment.URL_SERVICIOS}/reports/get_layout_simplificado_banorte/?token=${this.token}&secret_key=${environment.SECRET_KEY}&start_date=${finicio}&end_date=${ffin}`;

    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );
  }

  getReporteConsultasBuro( date1, date2 ) {

    const url = `${environment.URL_SERVICIOS}/buroConsultsReport?fecha_inicio=${date1}&fecha_fin=${date2}&token=${this.token}&secret_key=${environment.SECRET_KEY}`;

    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );

  }


  getReporteCreditosGPA( ) {

    const url = `${environment.URL_SERVICIOS}/customer_credit_gpa_report?&token=${this.token}&secret_key=${environment.SECRET_KEY}`;

    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );

  }

  getReporteCreditosYucatan( ) {

    const url = `${environment.URL_SERVICIOS}/customer_credit_gobierno_report?&token=${this.token}&secret_key=${environment.SECRET_KEY}`;

    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );

  }

  getRegistrationInfo( id ) {

    const url = `${environment.URL_SERVICIOS}/reports/customer_credit_id/${id}/get_customer?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );

  }

  getRegistrationInfo2( data ) {
    const url = `${this.path}/reports/customer_credit_id/${data.id}/get_customer`;

    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );

  }

  financialWorkers() {
      const url = `${environment.URL_SERVICIOS}/reports/job/FINANCIERA/financial_workers?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
      return this.http.get(url)
    
    }

  userRequest() {
      const url = `${environment.URL_SERVICIOS}/reports/user_id/${this.idUsuario}/user_requests?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
      return this.http.get(url)
    
    }

  generalCredits() {
      const url = `${environment.URL_SERVICIOS}/general_credits_report?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
      return this.http.get(url)
    
    }

  totalPortafolioByCompany() {
      const url = `${environment.URL_SERVICIOS}/get_total_portfolio_by_company?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
      return this.http.get(url)
    
    }

  creditosActivosByCompany() {
      const url = `${environment.URL_SERVICIOS}/get_active_credits_sorted_by_company?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
      return this.http.get(url)
    
    }

  executedCredits() {
      const url = `${environment.URL_SERVICIOS}/reports/executed_credits_customers?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
      return this.http.get(url)
    
    }

  executedCreditsByType(type) {
      const url = `${environment.URL_SERVICIOS}/reports/executed_credits_customers?customer_type=${type}&token=${this.token}&secret_key=${environment.SECRET_KEY}`;
      return this.http.get(url)
    
    }

  getSolicitudesCambioBancarios() {
      const url = `${environment.URL_SERVICIOS}/contributors/bank_change_requests?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
      return this.http.get(url).pipe(
        map((resp: any) => {
          return resp.data || [];
        })
      );
    }

  /* ============================================
     CREDITOS-REVOLVENTES: carga de saldos pendientes desde Excel/CSV.
     POST /revolving_credits/upload_pending (form-data, campo "file").
     secret_key y token van como query params; el Content-Type (multipart
     con boundary) lo pone el navegador automáticamente al usar FormData.
     ============================================ */
  uploadRevolvingPending(file: File) {
    const formData = new FormData();
    formData.append('file', file);

    const url = `${environment.URL_SERVICIOS}/revolving_credits/upload_pending?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

    return this.http.post(url, formData).pipe(
      map((resp: any) => resp)
    );
  }

  }
